import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, ListChecks } from 'lucide-react';
import SectionMasterDataManager from '../components/SectionMasterDataManager';

export default function SectionMasterDataPage({ category, title, description }) {
  const navigate = useNavigate();

  return (
    <div className="space-y-6" data-testid={`${category}-master-page`}>
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/stocktaking/dashboard')} data-testid="back-to-dashboard">
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
            <ListChecks className="h-6 w-6 text-slate-600" />
            {title}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        </div>
      </div>

      <Card>
        <CardContent className="pt-4">
          <SectionMasterDataManager category={category} title={title} />
        </CardContent>
      </Card>
    </div>
  );
}
